import { useCallback, useEffect, useRef } from 'react';

// Hook to handle the Command+K shortcut for opening the universal search menu
export const useCommandK = () => {
  const inputRef = useRef<HTMLInputElement>(null);

  const simulateClick = useCallback(() => {
    // simulate a click on the body to close any open dropdowns using mousedown
    const event = new MouseEvent('mousedown', {
      bubbles: true,
      cancelable: true,
      view: window,
    });
    document.body.dispatchEvent(event);

    // simulate a click on the input to open the universal search menu
    if (inputRef.current) {
      const event = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      });
      inputRef.current.dispatchEvent(event);
    }
  }, []);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault();
        simulateClick();
        inputRef.current?.focus();
      }
    },
    [simulateClick],
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  return inputRef;
};
